<script>

    import LoopEditor from './../LoopEditor';

	// Will contain the current slides per block. Usefull for once the component is re-initialized due to new HTML.
	let canvasBlockId2currentActivePage = {};

	//
	export default {

		extends: LoopEditor,

        data()
        {
        	return {
        		sliderHasAutoPlay: null,
            };
        },

        created()
        {
        	this.initOwl();
        	this.initRestoreActiveSlideAfterNewHtml();
        },

		beforeDestroy()
        {
			this.owlSliderElement

				// Stop listen for changed slides.
				.unbind('changed.owl.carousel', this.onSlideChanged);
        },

		methods: {

			initOwl()
            {
				this.owlSliderElement

                    // Listen for some events.
                    .on('changed.owl.carousel', this.onSlideChanged)

                    // Disable canvas selection on buttons.
                    .find('.owl-nav, .owl-dots')
                        .attr('data-canvas-selectable', false)
                        .end();

				this.pageComponent.reinitVueComponents(this.owlSliderElement);

				this.initAutoplay();
            },

            onSlideChanged(event)
            {
				// Slider may have cloned new slides. We need to init those related Vue components.
				this.pageComponent.removeVueComponents(this.owlSliderElement);

				// @ugly
				setTimeout(() => this.pageComponent.initVueComponents(this.owlSliderElement), 1);

            	// Clear selection. The active (editing) slide might get out of the screen.
				this.selection.setSelection(null);

				//
                this.storeActiveSlide(event);
            },

            storeActiveSlide(event)
            {
            	// Store
				canvasBlockId2currentActivePage[this.canvasBlock.id] = event.page.index;
            },

            initAutoplay()
            {
            	// Remember if it has autoplay or not.
				this.sliderHasAutoPlay = this.owlSliderElement.data('owl.carousel').options.autoplay;
            },

            manageAutoPlay()
            {
            	// @ugly Abort due to element is not present anymore? Block has been deleted?
				if(this.element.closest('body').length == 0 || !this.canvasBlock)
					return;

				// Stop or start autoplay.
                if(this.sliderHasAutoPlay && !this.loopItemIsSelected) {
					this.owlSliderElement.trigger('start.owl.autoplay');
				}
                else {
					this.owlSliderElement.trigger('stop.owl.autoplay');
				}
            },

			initRestoreActiveSlideAfterNewHtml()
			{
				// Determine page.
				let page = canvasBlockId2currentActivePage[this.canvasBlock.id] || 0;

				// Go to page.
				this.owlSliderElement.trigger('to.owl.carousel', [page, 0])
			},

            getLoopItemEditorByIndex(index)
            {
                // Get slide element.
                let slideElement = this.owlSliderElement.data('owl.carousel')._items[index].get(0);

                // Test children components.
                for(let child of this.$children)
                {
                    // Return child Vue component due to is match with slide?
                    if(child.element && $(child.element).parent().get(0) == slideElement) {
                        return child;
                    }
                }

                //
                return null;
            },

        },

        computed: {

			owlSliderElement()
            {
            	return $(this.element).is('.owl-carousel') ? $(this.element) : $(this.element).find('.owl-carousel');
			},

            activeEditorIsOneOfOurSlideComponents()
            {
            	return this.$children.indexOf(this.selection.currentSelection) !== -1;
            },

			itemSelector()
			{
				return this.editableData.itemSelector || '> .owl-item > *';
			},

            loopItemIsSelected()
            {
            	// Get first parent of selection.
            	let parent = this.pageComponent.selection.currentSelection;

            	// Loop parents.
            	while(parent)
                {
                	parent = parent.$parent;

                	// Selected due to parent matches?
					if(parent == this)
						return true;
                }

                // Not selected.
            	return false;
            },

	    },

        watch: {

			'pageComponent.selection.currentSelection'()
			{
				this.manageAutoPlay();
			},

		},

	}

</script>
